<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {useSecurityStore} from "@/stores/Security";
import {useAutoPaySectionStore} from "@/stores/AutoPaySection";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    setup() {
        const {$i18n, $router} = useTools();

        const {
            loading,
            total,
        } = useSharedData();

        const securityStore = useSecurityStore();
        const autoPaySectionStore = useAutoPaySectionStore();


        const search = ref(null);

        const headers = [
            {
                text: "",
                align: "start",
                sortable: false,
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.label"),
                align: "start",
                sortable: true,
                value: "name",
                width: "0%",
            },
            {
                text: $i18n.t("auto_pay_sections.variable"),
                align: "start",
                sortable: true,
                value: "variable",
                width: "0%",
            },
            {
                text: $i18n.t("auto_pay_sections.default_value"),
                align: "start",
                sortable: true,
                value: "initialValue",
            }
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'auto_pay_sections.edit', params: { id: item.id }})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'auto_pay_sections.delete', params: { id: item.id }})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/autoPaySections').then((response) => {
                autoPaySectionStore.setAutoPaySections(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "auto_pay_sections.view", params: {id: item.id}});
        }

        onMounted(() => findAll());

        return {
            securityStore,
            autoPaySectionStore,
            loading,
            headers,
            actions,
            total,
            search,
            view,
            findAll,
        }
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.auto_pay_sections')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                    @press="$router.push({ name: 'auto_pay_sections.add' })"
                />
            </template>

            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :search="search"
                    :items="autoPaySectionStore.autoPaySections"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <w-chip :text="item.name"/>
                    </template>
                    <template v-slot:[`item.variable`]="{ item }">
                        <w-inline-text bold :text="item.variable"/>
                    </template>
                    <template v-slot:[`item.initialValue`]="{ item }">
                        <w-chip outlined :text="item.initialValue"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>

        <router-view/>
    </div>
</template>